export const initialState = {
	courses: [],
	upcoming_courses: [],
	past_courses: [],
	forms_extra_content: null,
	logged_in: false,
	user: null,
	loading_courses: true,
	courses_loading_error: null,
	current_course_id: null,
	current_date_id: null,
	notifications: [],
	offline: false,
	terms_text: "",
	privacy_text: "",
	cookies_text: "",
};

export function reducer(draft, action) {
	switch (action.type) {
		case "LOGIN": {
			draft.logged_in = true;
			draft.user = action.payload;
			return;
		}
		case "LOGOUT": {
			draft.logged_in = false;
			draft.user = null;
			draft.courses = [];
			draft.upcoming_courses = [];
			draft.past_courses = [];
			draft.current_course_id = null;
			draft.current_date_id = null;
			draft.notifications = [];
			return;
		}
		case "SET_ONLINE": {
			draft.offline = false;
			return;
		}
		case "SET_OFFLINE": {
			draft.offline = true;
			return;
		}
		case "SET_NOTIFICATIONS": {
			draft.notifications = action.payload;
			return;
		}
		case "DELETE_NOTIFICATION": {
			const index = draft.notifications.findIndex(
				(notification) => notification.id == action.payload
			);
			draft.notifications.splice(index, 1);
			return;
		}
		case "SET_TERMS_TEXT": {
			draft.terms_text = action.payload;
			return;
		}
		case "SET_PRIVACY_TEXT": {
			draft.privacy_text = action.payload;
			return;
		}
		case "SET_COOKIES_TEXT": {
			draft.cookies_text = action.payload;
			return;
		}
		case "SET_LOADING_COURSES": {
			draft.loading_courses = true;
			draft.courses_loading_error = null;
			return;
		}
		case "SET_COURSES": {
			draft.courses = action.payload;
			draft.loading_courses = false;
			draft.courses_loading_error = null;
			return;
		}
		case "SET_FORMS_EXTRA_CONTENT": {
			draft.forms_extra_content = action.payload;
			return;
		}
		case "SET_UPCOMING_COURSES": {
			draft.upcoming_courses = action.payload;
			return;
		}
		case "SET_PAST_COURSES": {
			draft.past_courses = action.payload;
			return;
		}
		case "SET_COURSES_LOADING_ERROR": {
			draft.courses = [];
			draft.courses_loading_error = action.payload;
			draft.loading_courses = false;
			return;
		}
		case "SET_COURSE": {
			draft.current_course_id = action.payload?.id
				? action.payload?.id
				: null;
			return;
		}
		case "SET_DATE": {
			draft.current_date_id = action.payload?.id;
			return;
		}
		case "SET_COURSE_AND_DATE": {
			draft.current_course_id = action.payload.course.id;
			draft.current_date_id = action.payload.date.id;
			return;
		}
		case "SET_DATE_ATTENDANCE": {
			// Replace attendance array in courses array, find by course id and date id
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);
			const dateIndex = draft.courses[courseIndex].dates.findIndex(
				(date) => date.id === action.payload.date_id
			);
			draft.courses[courseIndex].dates[dateIndex].attendance =
				action.payload.attendance;
			return;
		}
		case "SET_DAILY_RISK_ASSESSMENT": {
			// Mark daily_risk_assessment as done for date
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);

			const dateIndex = draft.courses[courseIndex].dates.findIndex(
				(date) => date.id === action.payload.date_id
			);
			let assessment = {}
			assessment.answers = action.payload.answers
			draft.courses[courseIndex].dates[dateIndex][
				"risk_assessment"
			] = assessment;
			return;
		}
		case "SET_DATE_CHECKLIST_ITEM": {
			// Replace checklist array in courses array, find by course id and date id
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);
			const dateIndex = draft.courses[courseIndex].dates.findIndex(
				(date) => date.id === action.payload.date_id
			);
				
			draft.courses[courseIndex].dates[dateIndex].checklist[
				action.payload.item_name
			] = action.payload.item_val;
			return;
		}
		case "SET_STUDENT_HEALTH_QUESTIONNAIRE": {
			// Replace health_questionnaire array in courses array, find by course id and date id
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);
			const dateIndex = draft.courses[courseIndex].dates.findIndex(
				(date) => date.id === action.payload.date_id
			);
			const studentindex = draft.courses[courseIndex].dates[
				dateIndex
			].attendance.findIndex(
				(student) => student.student_id === action.payload.student_id
			);

			draft.courses[courseIndex].dates[dateIndex].attendance[studentindex][
				"health_questionnaire"
			] = action.payload.form;

			return;
		}
		case "SET_STUDENT_DETAILS": {
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);
			const dateIndex = draft.courses[courseIndex].dates.findIndex(
				(date) => date.id === action.payload.date_id
			);
			const studentindex = draft.courses[courseIndex].dates[
				dateIndex
			].attendance.findIndex(
				(student) => student.student_id === action.payload.student_id
			);

			// Find student, make copy and just replace first_name, last_name and email
			const student =
				draft.courses[courseIndex].dates[dateIndex].attendance[
					studentindex
				];
			const newStudent = {
				...student,
				first_name: action.payload.first_name,
				last_name: action.payload.last_name,
				email: action.payload.email,
			};
			draft.courses[courseIndex].dates[dateIndex].attendance[studentindex] =
				newStudent;

			return;
		}
		case 'REMOVE_STUDENT_FROM_DATE': {
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);
			const dateIndex = draft.courses[courseIndex].dates.findIndex(
				(date) => date.id === action.payload.date_id
			);
			const studentindex = draft.courses[courseIndex].dates[
				dateIndex
			].attendance.findIndex(
				(student) => student.student_id === action.payload.student_id
			);
			// console.log(action.payload)
			
			draft.courses[courseIndex].dates[dateIndex].attendance.splice(studentindex, 1);
			return;
		}
		case 'SET_STUDENT_PHYSICAL_COMPETENCY': {
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);
			const dateIndex = draft.courses[courseIndex].dates.findIndex(
				(date) => date.id === action.payload.date_id
			);
			const studentindex = draft.courses[courseIndex].dates[
				dateIndex
			].attendance.findIndex(
				(student) => student.student_id === action.payload.student_id
			);
			console.log(action.payload)
			// Set has_physical_competency on student to action.payload.val
			draft.courses[courseIndex].dates[dateIndex].attendance[studentindex][
				"has_physical_competency"
			] = action.payload.val;

			// Set physical_competency_result on student to action.payload.result
			draft.courses[courseIndex].dates[dateIndex].attendance[studentindex][
				"physical_competency_result"
			] = action.payload.result;
			
			return;
		}
		case "SET_STUDENT_HAS_REFERRAL": {
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);
			const dateIndex = draft.courses[courseIndex].dates.findIndex(
				(date) => date.id === action.payload.date_id
			);
			const studentindex = draft.courses[courseIndex].dates[
				dateIndex
			].attendance.findIndex(
				(student) => student.student_id === action.payload.student_id
			);

			// Set has_referral on student to action.payload.val
			draft.courses[courseIndex].dates[dateIndex].attendance[studentindex][
				"has_referral_form"
			] = action.payload.val;

			return;
		}
		case "SET_WRITTEN_ASSESSMENT_FOR_STUDENT": {
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);
			// Find student in course
			const studentIndex = draft.courses[courseIndex].students.findIndex(
				(student) => student.id === action.payload.student_id
			);

			// Set written_assessment on student to action.payload.assessment
			draft.courses[courseIndex].students[studentIndex][
				"written_assessment"
			] = action.payload.assessment;
			console.log(action.payload.assessment)
			return;
		}
		case "SET_COURSE_STUDENTS": {
			// Replace students array in courses array, find by course id
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);
			draft.courses[courseIndex].students = action.payload.students;
			return;
		}
		case "SET_COURSE_DATE_TEACHING_LOG" : {
			console.log(action.payload)
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);
			const dateIndex = draft.courses[courseIndex].dates.findIndex(
				(date) => date.id === action.payload.date_id
			);
			draft.courses[courseIndex].dates[dateIndex].teaching_logs = action.payload.val;
			return;
		}
		case "REMOVE_WITNESS_INCIDENT": {
			// Remove witness incident from course
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);
			
			// Find witness incident in course
			const witnessIncidentIndex = draft.courses[courseIndex].witness_incidents.findIndex(
				(witnessIncident) => witnessIncident.id == action.payload.incident_id
			);
			
			// Remove witness incident
			draft.courses[courseIndex].witness_incidents.splice(witnessIncidentIndex, 1);
			return;
		}

		case "SET_STUDENT_CERTIFICATES_SENT": {
			// Mark certificates as sent for students
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);

			const studentIds = action.payload.students;

			studentIds.forEach((studentId) => {
				const studentIndex = draft.courses[courseIndex].students.findIndex(
					(student) => student.id === studentId
				);
				draft.courses[courseIndex].students[
					studentIndex
				].certificate_sent_date = true;
			});
			return;
		}
		case "SET_COURSE_COMPLETED" : {
			// Mark course as completed
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);
			draft.courses[courseIndex].tutor_completed_at = true;
			return;
		}
		case "UPDATE_COURSE_COMMENTS" : {
			// Update course comments
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);
			draft.courses[courseIndex].tutor_comments = action.payload.comments;
			return;
		}
		case "SET_COURSE_INCIDENTS": {
			// Replace students array in courses array, find by course id
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);
			draft.courses[courseIndex].incidents = action.payload.incidents;
			return;
		}
		case "SET_STUDENT_ATTENDANCE": {
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);
			const dateIndex = draft.courses[courseIndex].dates.findIndex(
				(date) => date.id === action.payload.date_id
			);
			const studentindex = draft.courses[courseIndex].dates[
				dateIndex
			].attendance.findIndex(
				(student) => student.student_id === action.payload.student_id
			);
			console.log(action.payload)
			// Set attendance on student to action.payload.val
			draft.courses[courseIndex].dates[dateIndex].attendance[studentindex][
				"attendance"
			] = action.payload.val;
			return;
		}
		case "SET_STUDENT_NON_ATTENDANCE": {
			const courseIndex = draft.courses.findIndex(
				(course) => course.id === action.payload.course_id
			);
			const dateIndex = draft.courses[courseIndex].dates.findIndex(
				(date) => date.id === action.payload.date_id
			);
			const studentindex = draft.courses[courseIndex].dates[
				dateIndex
			].attendance.findIndex(
				(student) => student.student_id === action.payload.student_id
			);
			console.log(action.payload)
			// Set attendance on student to action.payload.val
			draft.courses[courseIndex].dates[dateIndex].attendance[studentindex][
				"non_attendance"
			] = action.payload.val;
			return;
		}
		case "RESET": {
			return initialState;
		}
		default: {
			throw Error("Unknown action: " + action.type);
		}
	}
}
